import React, { useRef, useEffect, useState, useMemo } from "react";
import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";
import { axInst } from "../../Components/Login/Service";
import PvinFilter from "../../Components/Filters/PvinFilter";
import CustomerSummary from "../Pvin/CustomerSummary";
import IframeEmbed from "./IframeTest";

const Pvin = () => {
  const iframeRef = useRef(null);
  const [parArn, setParArn] = useState(null);

  const selectedFilter = useSelector(
    (state) => state.filtersPvin.selectedFilter
  );

  const isFilterEmpty =
    !selectedFilter || Object.keys(selectedFilter).length === 0;

  const PvinCustomerProfileApi = async (selectedFilter) => {
    try {
      const res = await axInst.post("pvin/customer-details", selectedFilter);
      return res.data;
    } catch (error) {
      console.error(
        "Error fetching customer profile:",
        error.response || error
      );
      throw error;
    }
  };

  const { data: pvindata } = useQuery({
    queryKey: ["pvinCustomerData", selectedFilter],
    queryFn: () => PvinCustomerProfileApi(selectedFilter),
    cacheTime: 0,
    staleTime: 0,
    enabled: !isFilterEmpty,
  });

  useEffect(() => {
    if (pvindata?.[0]?.PAR_ACCNT_ARN) {
      setParArn(pvindata[0].PAR_ACCNT_ARN);
    } else {
      setParArn(null);
    }
  }, [pvindata]);

  // Build iframe URL without encryption
  const iframeUrl = useMemo(() => {
    if (!parArn) return null;
    return `${process.env.REACT_APP_CUSTOMER_INTEGRATED_URL}?parArn=${parArn}&isDealer=true`;
  }, [parArn]);

  return (
    <div className="flex flex-col flex-grow">
      <div className="px-2">
        <PvinFilter />
      </div>

      {isFilterEmpty ? (
        <CustomerSummary />
      ) : (
        <div className="p-2" style={{ height: "80vh" }}>
          <IframeEmbed url={iframeUrl} />
        </div>
      )}
    </div>
  );
};

export default Pvin;
